export default __webpack_public_path__ + "static/media/money-back.852e23b4.svg";